import { call, put } from "redux-saga/effects";

import * as API from "../../../Connections/APIs/DriverManagement";
import * as Action from "../../Actions/DriverManagement/Action";

export function* creacteDriverWithfileSaga(action) {
  try {
    const response = yield call(API.CreateDriverWithFileApi, action.data, action.DriverOrDistributor);
    yield put(Action.creacteDriverWithfileSuccessAction(response.data));
  } catch (error) {
    yield put(Action.creacteDriverWithfileFailAction(error));
  }
}

export function* deleteDriverSaga(action) {
  try {
    const response = yield call(API.DeleteDriverApi, action.id);
    yield put(Action.deleteDriverSuccessAction(response.data));
  } catch (error) {
    yield put(Action.deleteDriverFailAction(error));
  }
}

export function* editDriverSaga(action) {
  try {
    const response = yield call(API.EditDriverApi, action.data);
    yield put(Action.editDriverSuccessAction(response.data));
  } catch (error) {
    yield put(Action.editDriverFailAction(error));
  }
}

export function* createDriverWithVehicleSaga(action) {
  try {
    const response = yield call(API.CreateDriverWithVehicleApi, action.data);
    yield put(Action.createDriverWithVehicleSuccessAction(response.data));
  } catch (error) {
    yield put(Action.createDriverWithVehicleFailAction(error));
  }
}

export function* changeDriverPasswordSaga(action) {
  try {
    const response = yield call(API.changeDriverPasswordApi, action.data);
    yield put(Action.changeDriverPasswordSuccessAction(response.data));
  } catch (error) {
    yield put(Action.changeDriverPasswordFailAction(error));
  }
}

export function* getDriverSaga(action) {
  try {
    const response = yield call(API.GetDriverApi, action.driverData);
    yield put(Action.getDriverSuccessAction(response.data));
  } catch (error) {
    yield put(Action.getDriverFailAction(error));
  }
}

export function* getAllDriversOfPlanSaga(action) {
  try {
    const response = yield call(API.getAllDriversOfPlanApi, action.data);
    yield put(Action.getAllDriversOfPlanSuccessAction(response.data));
  } catch (error) {
    yield put(Action.getAllDriversOfPlanFailAction(error));
  }
};

export function* searchTenantDriversSaga(action) {
  try {
    const response = yield call(API.SearchTenantDriversApi, action.vehicleParam);
    yield put(Action.searchTenantDriversSuccessAction(response.data));
  } catch (error) {
    yield put(Action.searchTenantDriversFailAction(error));
  }
}

export function* searchTenantDriverPersonalSaga(action) {
  try {
    const response = yield call(API.SearchTenantDriverPersonalApi, action.query);
    yield put(Action.searchTenantDriverPersonalSuccessAction(response.data));
  } catch (error) {
    yield put(Action.searchTenantDriverPersonalFailAction(error));
  }
}

export function* CreateDistributorSaga(action) {
  try {
    const response = yield call(API.createDistributor, action.data);
    yield put(Action.CreateDistributorSuccessAction(response.data));
  } catch (error) {
    yield put(Action.CreateDistributorFailAction(error));
  }
}

export function* postDriverInfoSaga(action) {
  try {
    const response = yield call(API.postDriverInfoApi, action.data);
    yield put(Action.postDriverInfoSuccessAction(response.data));
  } catch (error) {
    yield put(Action.postDriverInfoFailAction(error));
  }
}

export function* activeMissionToDriverSaga(action) {
  try {
    const response = yield call(API.ActiveMissionToDriverApi, action.query);
    yield put(Action.activeMissionToDriveSuccessAction(response.data));
  } catch (error) {
    yield put(Action.activeMissionToDriveFailAction(error));
  }
}

export function* DeleteMissionFromDriverSaga(action) {
  try {
    const response = yield call(API.DeleteMissionFromDriverApi, action.data);
    yield put(Action.DeleteMissionFromDriverSuccessAction(response.data));
  } catch (error) {
    yield put(Action.DeleteMissionFromDriverFailAction(error));
  }
}
